import { html } from "common-tags";

export const MyNewsCompletionConfig = {
  button: {
    inMyNewsText: "START READING",
    otherPageText: html`Go to <i style="font-weight: 400;">my</i><b>NEWS</b>`,
  },
  description: html`
    You can now
    <ul>
      <li>access your <b>Daily 5</b> must-read articles</li>
      <li>
        access <i style="font-weight: 400;">my</i><b>NEWS</b> via the <b>SCMP app</b>. <wbr />Simply
        <download-link>download</download-link> and log in
      </li>
    </ul>
  `,
  headline: html`<i style="font-weight: 400;">my</i><b>NEWS</b> set-up is complete`,
  localStorageKey: "isShownMyNewsCompletionPopup",
};
